package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Software(
    val name: String,
    val stars: Int // Nombre d'étoiles (1 à 5)
)
